/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-nested-ternary */
/* eslint-disable operator-assignment */
import React, { useEffect, useState, useRef } from 'react'
import { Page, Text, View, Document, Image, Font, PDFViewer } from '@react-pdf/renderer'
import { useSelector } from 'react-redux'
import { useQuery, useMutation, useApolloClient } from 'react-apollo'
import SignaturePad from 'react-signature-canvas'
import gql from 'graphql-tag'
import moment from 'moment'
import { REACT_APP_API_URL } from 'apollo/REACT_APP_URL'
import LoadingComponent from 'components/VBMappReport/LoadingComponent'
import { Button, notification, Modal, Upload, Icon } from 'antd'
import s1 from 'assets/fonts/SourceSerifPro/SourceSerifPro-Regular.ttf'
import s2 from 'assets/fonts/SourceSerifPro/SourceSerifPro-SemiBold.ttf'
import axios from 'axios'
import {
  CREATE_SIGN_TH,
  UPDATE_SIGN_TH,
  IS_DOC_SIGNED,
  UPDATE_THERAPIST_SIGN,
  UPDATE_LEARNER_SIGN,
} from '../query'

Font.register({
  family: 'Source Serif Pro',
  fonts: [
    { src: s1, fontStyle: 'normal', fontWeight: 'light' },
    { src: s2, fontStyle: 'normal', fontWeight: 'bold' },
  ],
})

const peakId = 'VGFyZ2V0RGV0YWlsVHlwZTo4'

const sectionMain = {
  width: '100%',
  border: '1px solid black',
  color: 'black',
}
const section = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  borderBottom: '1px solid black',
}

const col = {
  width: '10%',
  textAlign: 'center',
  display: 'flex',
  borderRight: '1px solid black',
}

const bg = {
  backgroundColor: '#e8e8e8',
}

const sText = {
  fontSize: 9,
  padding: '4px 0',
  backgroundColor: '#fff',
}

const mText = {
  ...sText,
  fontSize: 10,
  margin: 'auto 0',
}

const borderBottom = { borderBottom: '1px solid black' }

const headerText = {
  fontSize: 10,
  fontWeight: 700,
  padding: '4px 0',
  margin: 'auto',
  alignSelf: 'center',
  width: '100%',
  backgroundColor: '#e8e8e8',
}

const headerTextBorder = {
  ...headerText,
  ...borderBottom,
}

const STUDENT_DETAILS = gql`
  query student($studentId: ID!, $childSessionId: ID!) {
    student(id: $studentId) {
      id
      firstname
      dob
      category {
        id
        category
      }
      clinicLocation {
        id
        location
      }
    }

    getSessionDataRecording(ChildSession: $childSessionId) {
      totalTarget
      mandCount
      behCount
      toiletData {
        id
        date
        time
        bowel
        urination
        prompted
      }

      behData {
        id
        frequency
        duration
        environment {
          id
          name
        }
        rate
        rateUnit
        studentBehaviorTemplate {
          id
          behavior {
            id
            behaviorName
          }
        }
      }

      mandData {
        dailyClick {
          id
          measurments
        }
        data
        promptedCount
        date
        createdAt
      }

      edges {
        node {
          id
          targets {
            id
            targetAllcatedDetails {
              id
              targetName
              DailyTrials
              targetType {
                id
                typeTar
              }
            }
          }
          sessionRecord {
            totalTrial
            totalCorrect
            totalError
            totalPrompt
            totalIncorrect
            totalNr

            physical
            verbal
            gestural
            textual

            edges {
              node {
                user {
                  id
                  username
                }
              }
            }
          }
          peakEquivalance {
            totalCorrect
            totalError
            totalPrompt
            totalTrial
          }
          peak {
            totalCorrect
            totalError
            totalPrompt
          }
          isBehReduction
          behReduction {
            totalCorrect
            totalIncorrect
            totalPrompt
            totalError
            totalTrial
            r1
            r2
          }
          isPeak
          isPeakEquivalance
          isBehRecording
          totalBehRecordingDuration
          behaviourRecording {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }

    childSessionDetails(id: $childSessionId) {
      id
      sessionDate
      duration
      feedback
      rating
      createdAt
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      caregiverReport
      nextSessionNeeds
      providerSignature {
        signature
        longitude
        latitude
        createdAt
        user {
          firstName
        }
      }
      caregiverSignature {
        signature
        longitude
        latitude
        createdAt
        user {
          firstName
        }
      }
    }

    getTargetTypesInSession(session: $childSessionId) {
      insideSession
      targetType {
        id
        typeTar
      }
    }
  }
`

const durationMapping = { SC: 'seconds', MN: 'minutes', HR: 'hours' }

const getInMilliseonds = (duration, currentFormat) => {
  if (currentFormat === 'SC') {
    return Number(duration) * 1000
  }
  if (currentFormat === 'MN') {
    return Number(duration) * 60 * 1000
  }
  if (currentFormat === 'HR') {
    return Number(duration) * 60 * 60 * 1000
  }
  if (currentFormat === 'DY') {
    return Number(duration) * 24 * 60 * 60 * 1000
  }

  return Number(duration)
}

const PrintableInvoice = ({ selectSessionId }) => {
  const english = /^[A-Za-z0-9]*$/
  const sigCanvas = useRef({})
  const [TotalTrials, setTotalTrials] = useState(0)
  const [CorrectTrials, setCorrectTrials] = useState(0)
  const [IncorrectTrials, setIncorrectTrials] = useState(0)
  const [NoTrials, setNoTrials] = useState(0)
  const [PromptedTrials, setPromptedTrials] = useState(0)
  const [r1, setR1] = useState(null)
  const [r2, setR2] = useState(null)
  const [behDuration, setBehDuration] = useState(0)
  const [behFrequency, setbehFrequency] = useState(0)
  const [behaviorData, setBehaviorData] = useState([])
  const [toiletData, setToiletData] = useState([])
  const [mandData, setMandData] = useState([])
  const [childSessionId, setChildSessionId] = useState(null)
  const [selectedStudent, setselectedStudent] = useState(null)
  const [signObj, setSignObj] = useState(null)
  const [targetsType, setTargetsType] = useState(null)
  const [location, setLocation] = useState(null)
  const [ProviderSignLocation, setProviderSignLocation] = useState(null)
  const [CaregiverSignLocation, setCaregiverSignLocation] = useState(null)
  const [ProviderSignLocationData, setProviderSignLocationData] = useState(null)
  const [CaregiverSignLocationData, setCaregiverSignLocationData] = useState(null)
  const [locationData, setLocationData] = useState(null)
  const [loadingLocation, setLoadingLocation] = useState(false)
  const [TimeStamp, setTimeStamp] = useState('')
  const [sign, setsign] = useState('')
  const [Role, setRole] = useState(JSON.parse(localStorage.getItem('role')))
  const [IsModalVisible, setIsModalVisible] = useState(false)
  const [SignImg, setSignImg] = useState('')
  const [ProviderSign, setProviderSign] = useState(null)
  const [CaregiverSign, setCaregiverSign] = useState(null)
  const [longitude, setlongitude] = useState()
  const [latitude, setlatitude] = useState()
  const [CareGiverReport, setCareGiverReport] = useState('')
  const [NextSessionNeeds, setNextSessionNeeds] = useState('')
  const abc =
    'data:image/png;base64,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'

  const client = useApolloClient()
  const ad = [
    {
      s1: '',
      t1: 'Receptive lang.deficits',
      s2: '',
      t2: 'Deficits in adapt. skills',
      s3: TotalTrials,
      t3: 'Total Trials',
      s4: r1,
      t4: r1 !== null ? 'r1' : '-',
    },
    {
      s1: '',
      t1: 'Functional comm. Defict',
      s2: '',
      t2: 'Deficits in safety skills',
      s3: CorrectTrials,
      t3: 'Correct Trials',
      s4: r2,
      t4: r2 !== null ? 'r2' : '-',
    },
    {
      s1: '',
      t1: 'Deficits in play skills ',
      s2: '',
      t2: 'Restricted interests',
      s3: PromptedTrials,
      t3: 'Prompted Trials',
      s4: behDuration,
      t4: 'Behavior Duration',
    },
    {
      s1: '-',
      t1: '-',
      s2: '-',
      t2: '-',
      s3: IncorrectTrials,
      t3: 'Incorrect Trials',
      s4: behFrequency,
      t4: 'Behavior Frequency',
    },
    {
      s1: '-',
      t1: '-',
      s2: '-',
      t2: '-',
      s3: NoTrials,
      t3: 'No Trials',
      s4: '-',
      t4: '-',
    },
  ]

  if (!selectSessionId) {
    return <p>Session Id Not Selected</p>
  }
  const { data: studentData, loading: studentLoading, error: studentError, refetch } = useQuery(
    STUDENT_DETAILS,
    {
      variables: {
        studentId: localStorage.getItem('studentId'),
        childSessionId: selectSessionId,
      },
    },
  )

  const { data: signData } = useQuery(IS_DOC_SIGNED, {
    variables: {
      childSessionId: selectSessionId,
    },
  })

  const [createSignTh, { loading: createThLoading }] = useMutation(CREATE_SIGN_TH)
  const [updateSignTh, { loading: updateThLoading }] = useMutation(UPDATE_SIGN_TH)
  const [updateTherapistSign, { data, loading }] = useMutation(UPDATE_THERAPIST_SIGN)
  const [updateLearnerSign, { data: data123 }] = useMutation(UPDATE_LEARNER_SIGN)

  const role = useSelector(state => state.user.role)

  useEffect(() => {
    setSignImg('')

    getLocation()
    const loc = window.navigator && window.navigator.geolocation
  }, [])

  useEffect(() => {
    if (studentData && studentData.getSessionDataRecording) {
      setBehaviorData(studentData.getSessionDataRecording?.behData)
      setToiletData(studentData.getSessionDataRecording?.toiletData)
      setMandData(studentData.getSessionDataRecording?.mandData)

      if (studentData.childSessionDetails) {
        setChildSessionId(studentData.childSessionDetails.id)
        const {
          createdAt,
          endLatitude,
          endLongitude,
          providerSignature,
          caregiverSignature,
          caregiverReport,
          nextSessionNeeds,
        } = studentData.childSessionDetails
        setProviderSign(providerSignature)
        setCaregiverSign(caregiverSignature)
        // const {}
        setLocation({ lat: endLatitude, long: endLongitude })
        setProviderSignLocation({
          lat: providerSignature?.latitude,
          long: providerSignature?.longitude,
        })
        setCaregiverSignLocation({
          lat: caregiverSignature?.latitude,
          long: caregiverSignature?.longitude,
        })
        setNextSessionNeeds(nextSessionNeeds)
        setCareGiverReport(caregiverReport)
      }

      const targets = studentData.getTargetTypesInSession?.map(item =>
        item.targetType.typeTar === 'Discrete Trial Training/Natural Environment Training'
          ? { typeTar: 'DET/NET', insideSession: item.insideSession }
          : { typeTar: item.targetType?.typeTar, insideSession: item.insideSession },
      )
      setTargetsType(targets)

      const item = studentData.getSessionDataRecording.edges
      const Mand = studentData.getSessionDataRecording.mandCount
      const Behaviours = studentData.getSessionDataRecording.behCount

      const sessionArray = []
      let No = 0
      let Prompted = 0
      let Correct = 0
      let Incorrect = 0
      let totalTrial = 0
      let tempr1 = 0
      let tempr2 = 0
      let tempDur = 0
      let tempFreq = 0
      const cardStyle = { padding: 5 }

      if (item !== undefined) {
        for (let i = 0; i < item.length; i += 1) {
          const obj = item[i].node.peak
          const peakObj = item[i].node.peakEquivalance
          const sessionObj = item[i].node.sessionRecord
          const sbtObj = item[i].node.behReduction
          tempr1 += sbtObj.r1
          tempr2 += sbtObj.r2
          tempFreq += item[i].node.behaviourRecording?.edges.length || 0
          tempDur += item[i].node.totalBehRecordingDuration || 0

          sessionArray.push({
            key: Math.random(),
            totalTrial:
              obj.totalPrompt +
              obj.totalError +
              obj.totalCorrect +
              sessionObj.totalTrial +
              peakObj.totalTrial +
              sbtObj.totalTrial,
            totalIncorrect:
              0 +
              peakObj.totalError +
              obj.totalError +
              sessionObj.totalIncorrect +
              sbtObj.totalIncorrect +
              sbtObj.totalError,
            totalPrompt:
              0 +
              peakObj.totalPrompt +
              obj.totalPrompt +
              sessionObj.totalPrompt +
              sbtObj.totalPrompt,
            totalCorrect:
              0 +
              peakObj.totalCorrect +
              obj.totalCorrect +
              sessionObj.totalCorrect +
              sbtObj.totalCorrect,
            totalNr: sessionObj.totalNr,
          })
        }

        sessionArray.forEach(entry => {
          totalTrial += entry.totalTrial
          Prompted += entry.totalPrompt
          Correct += entry.totalCorrect
          No += entry.totalNr
          Incorrect += entry.totalIncorrect
        })
        setTotalTrials(totalTrial)
        setCorrectTrials(Correct)
        setIncorrectTrials(Incorrect)
        setPromptedTrials(Prompted)
        setNoTrials(No)
        setR1(tempr1 === 0 ? null : tempr1)
        setR2(tempr2 === 0 ? null : tempr2)
        setbehFrequency(tempFreq)
        setBehDuration((Number(tempDur) / 1000).toFixed(0))
      }
    }
  }, [studentData])

  useEffect(() => {
    if (location) {
      const getPlace = async () => {
        try {
          setLoadingLocation(true)
          const res = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${location?.lat}&lon=${location?.long}&zoom=18&addressdetails=1`,
          )
          setLocationData(res?.data)
        } catch (err) {
          setLocationData({ error: 'Not able to fetch' })
        }
        setLoadingLocation(false)
      }
      getPlace()
    }
  }, [location, client])

  useEffect(() => {
    if (ProviderSignLocation) {
      const getPlace = async () => {
        try {
          const res = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${ProviderSignLocation?.lat}&lon=${ProviderSignLocation?.long}&zoom=18&addressdetails=1`,
          )
          setProviderSignLocationData(res?.data)
        } catch (err) {
          console.error('Error: Unable to get location data', err)
          setProviderSignLocationData({ error: 'Not able to fetch' })
        }
      }
      getPlace()
    }
  }, [ProviderSignLocation, client])

  useEffect(() => {
    if (CaregiverSignLocation) {
      const getPlace = async () => {
        try {
          const res = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${CaregiverSignLocation?.lat}&lon=${CaregiverSignLocation?.long}&zoom=18&addressdetails=1`,
          )
          setCaregiverSignLocationData(res?.data)
        } catch (err) {
          console.error('Error: Unable to get location data', err)
          setCaregiverSignLocationData({ error: 'Not able to fetch' })
        }
      }
      getPlace()
    }
  }, [CaregiverSignLocation, client])

  useEffect(() => {
    if (signData) {
      setSignObj(signData.signdocByChildSessionId)
    } else {
      setSignObj(null)
    }
  }, [signData])

  const getSignImg = info => {
    const { status } = info.file
    if (status === 'done' && info.file?.response) {
      const filelist = info.file.response?.fileUrl
      setSignImg(filelist)
    }
  }

  const showModal = () => {
    setSignImg()

    setIsModalVisible(true)
  }
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition)
    }
  }
  const showPosition = position => {
    setlongitude(position.coords.longitude)
    setlatitude(position.coords.latitude)
  }

  const handleOk = () => {
    getLocation()
    const getlocation = navigator && navigator.geolocation
    if (getlocation) {
      if (role === 'therapist' || role === 'school_admin') {
        updateTherapistSign({
          variables: {
            childId: childSessionId,
            signImg: SignImg,
            longitude,
            latitude,
          },
        })
          .then(res => {
            notification.success({
              message: 'Document signed successfully',
            })
            setSignImg(null)
            sigCanvas.current.clear()
            refetch()
          })
          .catch(erro => console.log(erro))
      } else {
        updateLearnerSign({
          variables: {
            childId: childSessionId,
            signImg: SignImg,
            latitude,
            longitude,
          },
        })
          .then(res => {
            notification.success({
              message: 'Document signed successfully',
            })
            setSignImg(null)
            sigCanvas.current.clear()
            refetch()
          })
          .catch(erro => console.log(erro))
      }
      setIsModalVisible(false)
    }
  }

  const clear = () => {
    sigCanvas.current.clear()
    setSignImg('')
  }
  const save = () => {
    setSignImg(sigCanvas.current.getTrimmedCanvas().toDataURL('image/png'))
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    sigCanvas.current.clear()
    setSignImg('')
  }

  function convertMsToHM(milliseconds) {
    return new Date(milliseconds * 1000).toISOString().slice(11, -1)
  }

  const getObservedTime = d => {
    const hr = Math.floor(d / 3600)
    const min = Math.floor((d % 3600) / 60)
    const sec = Math.floor((d % 3600) % 60)
    return `${hr}:${min}:${sec}`
  }

  return (
    <div>
      {studentData && !loadingLocation ? (
        <>
          <div style={{ width: '100px', margin: '10px' }}>
            <Button
              // loading={createThLoading || updateThLoading}
              type="primary"
              onClick={() => showModal()}
            >
              Sign Document
            </Button>
          </div>
          <PDFViewer
            style={{
              width: '1000px',
              height: '800px',
              alignSelf: 'center',
              margin: 'auto',
              display: 'block',
            }}
          >
            <Document>
              <Page
                size={[700, 1000]}
                style={{
                  flexDirection: 'row',
                  backgroundColor: '#fff',
                  padding: 10,
                }}
                wrap={false}
                scale={5}
              >
                <View style={{ width: '100%', height: '100%', margin: 'auto' }}>
                  <View style={sectionMain}>
                    <View style={{ ...section }}>
                      <View style={{ ...col, width: '10%' }}>
                        <Text style={sText}>Client details</Text>
                        <Text style={sText}> </Text>
                      </View>
                      <View style={col}>
                        <Text style={{ fontSize: 15 }}>{studentData?.student.firstname} </Text>
                      </View>
                      <View style={{ ...col, width: '12%' }}>
                        <Text style={headerTextBorder}>DOB </Text>
                        <Text style={mText}>
                          {studentData?.student.dob &&
                            moment(studentData?.student.dob).format('DD/MM/YYYY')}
                        </Text>
                      </View>
                      <View style={{ ...col, width: '12%' }}>
                        <Text style={headerTextBorder}>Date</Text>
                        <Text style={mText}>{studentData?.childSessionDetails?.sessionDate}</Text>
                      </View>
                      <View style={{ ...col, width: '25%' }}>
                        <Text style={headerTextBorder}>Location</Text>
                        <Text style={mText}>{studentData?.student.clinicLocation?.location} </Text>
                      </View>
                      <View style={{ ...col, width: '12%' }}>
                        <Text style={headerTextBorder}>Start Time</Text>
                        <Text style={mText}>
                          {moment(studentData?.childSessionDetails?.createdAt).format('HH:mm:ss', {
                            trim: false,
                          })}
                        </Text>
                      </View>
                      <View style={{ ...col }}>
                        <Text style={headerTextBorder}>Duration</Text>
                        <Text style={mText}>
                          {convertMsToHM(studentData?.childSessionDetails?.duration)}
                          {/* {studentData?.childSessionDetails?.duration && moment
                            .duration(studentData?.childSessionDetails?.duration, 'milliseconds')
                            .format('HH:mm:ss', { trim: false })} */}
                        </Text>
                      </View>
                      <View style={{ ...col, borderRight: 'none' }}>
                        <Text style={headerTextBorder}>Targets</Text>
                        <Text style={mText}>
                          {studentData?.getSessionDataRecording?.totalTarget}{' '}
                        </Text>
                      </View>
                    </View>

                    <View style={{ ...section }}>
                      <View style={{ ...col, width: '10%', backgroundColor: '#e8e8e8' }}>
                        <Text style={headerText}>Provider </Text>
                      </View>
                      <View style={{ ...col, width: '51%' }}>
                        <Text style={{ ...mText, textAlign: 'center' }}>
                          {
                            studentData.getSessionDataRecording.edges[0]?.node.sessionRecord
                              ?.edges[0]?.node.user?.username
                          }
                        </Text>
                      </View>
                      <View style={{ ...col, width: '10%', backgroundColor: '#e8e8e8' }}>
                        <Text style={headerText}>Category </Text>
                      </View>
                      <View style={{ ...col, borderRight: 'none', width: '29%' }}>
                        <Text style={{ ...mText, textAlign: 'left', paddingLeft: 4 }}>
                          {studentData?.student.category?.category}
                        </Text>
                      </View>
                    </View>

                    <View style={{ ...section }}>
                      <View style={{ ...col, width: '50%', ...bg }}>
                        <Text style={headerText}>INTERVENTIONS USED THROUGHOUT SESSION </Text>
                      </View>
                      <View style={{ ...col, width: '50%', ...bg, borderRight: 'none' }}>
                        <Text style={headerText}>RESPONSE TO INTERVENTIONS</Text>
                      </View>
                    </View>

                    <View style={{ ...section, borderBottom: 'none' }}>
                      <View style={{ width: '50%', flexDirection: 'column' }}>
                        <View style={section}>
                          <View style={{ ...col, width: '42%' }}>
                            <Text style={sText}>{targetsType && targetsType[0]?.typeTar}</Text>
                          </View>
                          <View style={{ ...col, width: '8%' }}>
                            <Text style={sText}>
                              {targetsType && targetsType[0]?.insideSession === true ? 'T' : 'F'}
                            </Text>
                          </View>
                          <View style={{ ...col, width: '42%' }}>
                            <Text style={sText}>{targetsType && targetsType[1]?.typeTar}</Text>
                          </View>
                          <View style={{ ...col, width: '8%' }}>
                            <Text style={sText}>
                              {targetsType && targetsType[1]?.insideSession === true ? 'T' : 'F'}
                            </Text>
                          </View>
                        </View>
                        <View style={section}>
                          <View style={{ ...col, width: '42%' }}>
                            <Text style={sText}>{targetsType && targetsType[2]?.typeTar}</Text>
                          </View>
                          <View style={{ ...col, width: '8%' }}>
                            <Text style={sText}>
                              {targetsType && targetsType[2]?.insideSession === true ? 'T' : 'F'}
                            </Text>
                          </View>
                          <View style={{ ...col, width: '42%' }}>
                            <Text style={sText}>{targetsType && targetsType[3]?.typeTar}</Text>
                          </View>
                          <View style={{ ...col, width: '8%' }}>
                            <Text style={sText}>
                              {targetsType && targetsType[3]?.insideSession === true ? 'T' : 'F'}
                            </Text>
                          </View>
                        </View>
                        <View style={section}>
                          <View style={{ ...col, width: '42%' }}>
                            <Text style={sText}>{targetsType && targetsType[4]?.typeTar}</Text>
                          </View>
                          <View style={{ ...col, width: '8%' }}>
                            <Text style={sText}>
                              {targetsType && targetsType[4]?.insideSession === true ? 'T' : 'F'}
                            </Text>
                          </View>
                          <View style={{ ...col, width: '42%' }}>
                            <Text style={sText}>{targetsType && targetsType[5]?.typeTar}</Text>
                          </View>
                          <View style={{ ...col, width: '8%' }}>
                            <Text style={sText}>
                              {targetsType && targetsType[5]?.insideSession === true ? 'T' : 'F'}
                            </Text>
                          </View>
                        </View>

                        <View style={section}>
                          <View style={{ ...col, width: '42%' }}>
                            <Text style={sText}>{targetsType && targetsType[6]?.typeTar}</Text>
                          </View>
                          <View style={{ ...col, width: '8%' }}>
                            <Text style={sText}>
                              {targetsType && targetsType[6]?.insideSession === true ? 'T' : 'F'}
                            </Text>
                          </View>
                          <View style={{ ...col, width: '42%' }}>
                            <Text style={sText}>{targetsType && targetsType[7]?.typeTar}</Text>
                          </View>
                          <View style={{ ...col, width: '8%' }}>
                            <Text style={sText}>
                              {targetsType && targetsType[7]?.insideSession === true ? 'T' : 'F'}
                            </Text>
                          </View>
                        </View>
                        <View style={{ ...section, borderBottom: 'none' }}>
                          <View style={{ ...col, width: '42%' }}>
                            <Text style={sText}>{targetsType && targetsType[8]?.typeTar}</Text>
                          </View>
                          <View style={{ ...col, width: '8%' }}>
                            <Text style={sText}>-</Text>
                          </View>
                          <View style={{ ...col, width: '42%' }}>
                            <Text style={sText}>{targetsType && targetsType[8]?.typeTar}</Text>
                          </View>
                          <View style={{ ...col, width: '8%' }}>
                            <Text style={sText}>-</Text>
                          </View>
                        </View>
                      </View>
                      <View style={{ width: '50%', flexDirection: 'column' }}>
                        {ad.map((item, ind) => {
                          return (
                            <View
                              style={
                                ind === ad.length - 1
                                  ? { ...section, borderBottom: 'none' }
                                  : { ...section }
                              }
                            >
                              <View style={{ ...col, width: '42%' }}>
                                <Text style={sText}>{item.t3}</Text>
                              </View>
                              <View style={{ ...col, width: '8%' }}>
                                <Text style={sText}>{item.s3}</Text>
                              </View>
                              <View style={{ ...col, width: '42%' }}>
                                <Text style={sText}>{item.t4}</Text>
                              </View>
                              <View style={{ ...col, width: '8%', borderRight: 'none' }}>
                                <Text style={sText}>{item.s4}</Text>
                              </View>
                            </View>
                          )
                        })}
                      </View>
                    </View>

                    <View
                      style={{ ...section, borderBottom: 'none', borderTop: '1px solid black' }}
                    >
                      <View
                        style={{
                          ...col,
                          ...bg,
                          ...borderBottom,
                          justifyContent: 'center',
                          flexDirection: 'row',
                          width: '4%',
                          alignItems: 'center',
                          fontSize: 9,
                        }}
                      >
                        <View style={{ flexDirection: 'column', width: '50%', margin: 'auto 0' }}>
                          <Text>D</Text>
                          <Text>E</Text>
                          <Text>C</Text>
                          <Text>E</Text>
                          <Text>L</Text>
                        </View>
                        <View style={{ flexDirection: 'column', width: '50%' }}>
                          <Text> </Text>
                          <Text>T</Text>
                          <Text>A</Text>
                          <Text>R</Text>
                          <Text>G</Text>
                          <Text>E</Text>
                          <Text>T</Text>
                          <Text> </Text>
                        </View>
                      </View>

                      <View style={{ width: '96%', flexDirection: 'column' }}>
                        <View style={{ ...section, backgroundColor: '#e8e8e8' }}>
                          <View style={{ ...col, width: '3%' }}>
                            <Text style={headerText}>#</Text>
                          </View>
                          <View style={{ ...col, width: '33%' }}>
                            <Text style={headerText}>BEHAVIOR</Text>
                          </View>
                          <View style={{ ...col, width: '33%' }}>
                            <Text style={headerText}>FREQUENCY</Text>
                          </View>
                          <View style={{ ...col, width: '33%', borderRight: 'none' }}>
                            <Text style={headerText}>DURATION</Text>
                          </View>
                        </View>
                        {behaviorData.map((item, index) => {
                          console.log('item>>>', item)
                          const duration = getInMilliseonds(item.duration, item.rateUnit)
                          console.log('miliseconds>>', duration, getObservedTime(item.duration))
                          return (
                            <View style={{ ...section }}>
                              <View style={{ ...col, width: '3%' }}>
                                <Text style={mText}>{index + 1}</Text>
                              </View>
                              <View style={{ ...col, width: '33%' }}>
                                <Text style={sText}>
                                  {item.studentBehaviorTemplate?.behavior?.behaviorName}
                                </Text>
                              </View>
                              <View style={{ ...col, width: '33%' }}>
                                <Text style={sText}>{item.frequency}</Text>
                              </View>
                              <View style={{ ...col, width: '33%', borderRight: 'none' }}>
                                <Text style={mText}>{getObservedTime(item.duration)}</Text>
                              </View>
                            </View>
                          )
                        })}
                      </View>
                    </View>

                    <View style={{ ...section, borderBottom: 'none' }}>
                      <View
                        style={{
                          ...col,
                          ...bg,
                          justifyContent: 'center',
                          flexDirection: 'row',
                          width: '4%',
                          alignItems: 'center',
                          fontSize: 9,
                        }}
                      >
                        <View style={{ flexDirection: 'column', width: '50%', margin: 'auto 0' }}>
                          <Text>D</Text>
                          <Text>A</Text>
                          <Text>I</Text>
                          <Text>L</Text>
                          <Text>Y</Text>
                        </View>
                        <View style={{ flexDirection: 'column', width: '50%' }}>
                          <Text> </Text>
                          <Text>V</Text>
                          <Text>I</Text>
                          <Text>T</Text>
                          <Text>A</Text>
                          <Text>L</Text>
                          <Text>S</Text>
                          <Text> </Text>
                        </View>
                      </View>

                      <View style={{ width: '96%', flexDirection: 'column' }}>
                        <View style={{ ...section, ...bg, borderTop: '1px solid black' }}>
                          <View style={{ ...col, width: '35%', ...bg }}>
                            <Text style={headerText}>MAND DATA </Text>
                          </View>
                          <View style={{ ...col, width: '65%', ...bg, borderRight: 'none' }}>
                            <Text style={headerText}>TOILET DATA</Text>
                          </View>
                        </View>
                        <View style={{ ...section, borderBottom: 'none' }}>
                          <View style={{ ...col, width: '35%', ...bg }}>
                            <View style={{ ...section, ...bg }}>
                              <View style={{ ...col }}>
                                <Text style={headerText}>#</Text>
                              </View>
                              <View style={{ ...col, width: '52%' }}>
                                <Text style={headerText}>MAND NAME</Text>
                              </View>
                              <View style={{ ...col, width: '20%' }}>
                                <Text style={headerText}>P</Text>
                              </View>
                              <View style={{ ...col, width: '20%', borderRight: 'none' }}>
                                <Text style={headerText}>I</Text>
                              </View>
                            </View>
                          </View>
                          <View style={{ ...col, width: '65%', ...bg, borderRight: 'none' }}>
                            <View style={{ ...section, ...bg }}>
                              <View style={{ ...col }}>
                                <Text style={headerText}>#</Text>
                              </View>
                              <View style={{ ...col, width: '30%' }}>
                                <Text style={headerText}>URINATION TIME</Text>
                              </View>
                              <View style={{ ...col, width: '30%' }}>
                                <Text style={headerText}>PROMPTED</Text>
                              </View>
                              <View style={{ ...col, width: '30%', borderRight: 'none' }}>
                                <Text style={headerText}>BOWEL MOVEMENT</Text>
                              </View>
                            </View>
                          </View>
                        </View>

                        <View style={{ ...section, borderBottom: 'none' }}>
                          <View style={{ width: '35%', flexDirection: 'column' }}>
                            {mandData.map((item, index) => {
                              return (
                                <View style={section}>
                                  <View style={{ ...col, ...bg }}>
                                    <Text style={sText}>{index + 1}</Text>
                                  </View>
                                  <View style={{ ...col, width: '52%' }}>
                                    <Text style={sText}>{item.dailyClick?.measurments}</Text>
                                  </View>
                                  <View style={{ ...col, width: '20%' }}>
                                    <Text style={sText}>{item.promptedCount}</Text>
                                  </View>
                                  <View style={{ ...col, width: '20%' }}>
                                    <Text style={sText}>{item.data}</Text>
                                  </View>
                                </View>
                              )
                            })}
                          </View>
                          <View style={{ width: '65%', flexDirection: 'column' }}>
                            {toiletData.map((item, index) => {
                              return (
                                <View style={section}>
                                  <View style={{ ...col, ...bg }}>
                                    <Text style={sText}>{index + 1}</Text>
                                  </View>
                                  <View style={{ ...col, width: '30%' }}>
                                    <Text style={sText}>{item.time}</Text>
                                  </View>
                                  <View style={{ ...col, width: '30%' }}>
                                    <Text style={sText}>
                                      {item.prompted === true ? 'YES' : 'NO'}
                                    </Text>
                                  </View>
                                  <View style={{ ...col, width: '30%', borderRight: 'none' }}>
                                    <Text style={sText}>{item.bowel === true ? 'YES' : 'NO'}</Text>
                                  </View>
                                </View>
                              )
                            })}
                          </View>
                        </View>
                      </View>
                    </View>

                    <View
                      style={{
                        ...section,
                        textAlign: 'center',
                        borderTop: '1px solid black',
                        borderBottom: 'none',
                      }}
                    >
                      <Text style={headerText}>ACQUISITION SKILLS</Text>
                    </View>

                    <View
                      style={{
                        ...section,
                        backgroundColor: '#e8e8e8',
                        borderTop: '1px solid black',
                      }}
                    >
                      <View style={{ ...col }}>
                        <Text style={headerText}>#</Text>
                      </View>
                      <View style={{ ...col, width: '72%' }}>
                        <Text style={headerText}>Objective</Text>
                      </View>
                      <View style={{ ...col, width: '20%', borderRight: 'none' }}>
                        <Text style={headerText}>Correct Trials</Text>
                      </View>
                    </View>
                    {studentData.getSessionDataRecording.edges.map((item, index) => {
                      return (
                        <View style={{ ...section }}>
                          {item.node.isBehReduction ? (
                            <>
                              <View style={{ ...col }}>
                                <Text style={sText}>{index + 1}</Text>
                              </View>
                              <View style={{ ...col, width: '72%' }}>
                                <Text style={sText}>
                                  {item.node.targets.targetAllcatedDetails.targetName}
                                </Text>
                              </View>
                              <View style={{ ...col, width: '20%', borderRight: 'none' }}>
                                <Text style={sText}>{item.node.behReduction.totalCorrect}</Text>
                              </View>
                            </>
                          ) : item.node.isPeakEquivalance ? (
                            <>
                              <View style={{ ...col }}>
                                <Text style={sText}>{index + 1}</Text>
                              </View>
                              <View style={{ ...col, width: '72%' }}>
                                <Text style={sText}>
                                  {item.node.targets.targetAllcatedDetails.targetName}
                                </Text>
                              </View>
                              <View style={{ ...col, width: '20%', borderRight: 'none' }}>
                                <Text style={sText}>{item.node.peakEquivalance.totalCorrect}</Text>
                              </View>
                            </>
                          ) : item.node.targets.targetAllcatedDetails.targetType.id === peakId ? (
                            <>
                              <View style={{ ...col }}>
                                <Text style={sText}>{index + 1}</Text>
                              </View>
                              <View style={{ ...col, width: '72%' }}>
                                <Text style={sText}>
                                  {item.node.targets.targetAllcatedDetails.targetName}
                                </Text>
                              </View>
                              <View style={{ ...col, width: '20%', borderRight: 'none' }}>
                                <Text style={sText}>{item.node.peak.totalCorrect}</Text>
                              </View>
                            </>
                          ) : (
                            <>
                              <View style={{ ...col }}>
                                <Text style={sText}>{index + 1}</Text>
                              </View>
                              <View style={{ ...col, width: '72%' }}>
                                <Text style={sText}>
                                  {item.node.targets.targetAllcatedDetails.targetName}
                                </Text>
                              </View>
                              <View style={{ ...col, width: '20%', borderRight: 'none' }}>
                                <Text style={sText}>{item.node.sessionRecord?.totalCorrect}</Text>
                              </View>
                            </>
                          )}
                        </View>
                      )
                    })}

                    <View style={section}>
                      <View
                        style={{
                          ...col,
                          width: '5%',
                          textAlign: 'center',
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'row',
                          backgroundColor: '#e8e8e8',
                          fontSize: 11,
                        }}
                      >
                        <View style={{ flexDirection: 'column', width: '100%', margin: 'auto 0' }}>
                          <Text>N</Text>
                          <Text>O</Text>
                          <Text>T</Text>
                          <Text>E</Text>
                          <Text>S</Text>
                        </View>
                      </View>
                      <View
                        style={{
                          padding: 0,
                          width: '95%',
                          alignItems: 'center',
                          flexDirection: 'column',
                        }}
                      >
                        <View
                          style={{
                            width: '100%',
                            height: 140,
                            alignItems: 'center',
                            flexDirection: 'row',
                          }}
                        >
                          <View
                            style={{
                              width: '60%',
                              height: '100%',
                              flexDirection: 'column',
                              borderRight: '1px solid black',
                            }}
                          >
                            <View
                              style={{
                                width: '100%',
                                backgroundColor: '#e8e8e8',
                                textAlign: 'center',
                                borderBottom: '1px solid black',
                              }}
                            >
                              <Text style={{ padding: 8, fontSize: 11 }}>CAREGIVER REPORT</Text>
                            </View>
                            <View
                              style={{
                                width: '100%',
                                height: '100%',
                              }}
                            >
                              <Text style={{ padding: 8, fontSize: 11 }}>
                                {CareGiverReport &&
                                  CareGiverReport?.replace('<p>', '')
                                    ?.replace('</p>', '')
                                    ?.replace('<strong>', '')
                                    ?.replace('</strong>', '')
                                    ?.replace('<em>', '')
                                    ?.replace('</em>', '')}
                              </Text>
                            </View>
                          </View>
                          <View
                            style={{
                              width: '40%',
                              height: '100%',
                              flexDirection: 'column',
                            }}
                          >
                            <View
                              style={{
                                width: '100%',
                                backgroundColor: '#e8e8e8',
                                textAlign: 'center',
                                borderBottom: '1px solid black',
                              }}
                            >
                              <Text style={{ padding: 8, fontSize: 11 }}>
                                NEEDS FOR NEXT SESSION
                              </Text>
                            </View>
                            <View
                              style={{
                                width: '100%',
                                height: '100%',
                              }}
                            >
                              <Text style={{ padding: 8, fontSize: 11 }}>
                                {NextSessionNeeds &&
                                  NextSessionNeeds?.replace('<p>', '')
                                    ?.replace('</p>', '')
                                    ?.replace('<strong>', '')
                                    ?.replace('</strong>', '')
                                    ?.replace('<em>', '')
                                    ?.replace('</em>', '')}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </View>
                    </View>

                    <View style={{ ...section }}>
                      <View style={{ ...col, width: '100%', flexDirection: 'column' }}>
                        <View
                          style={{
                            width: '100%',
                            backgroundColor: '#e8e8e8',
                            textAlign: 'center',
                            borderBottom: '1px solid black',
                          }}
                        >
                          <Text style={headerText}>SESSION SUMMARY</Text>
                        </View>
                        <View
                          style={{
                            width: '100%',
                            padding: 4,
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 12,
                              textAlign: 'left',
                              fontWeight: 500,
                              paddingLeft: 10,
                            }}
                          >
                            Feedback :
                            <Text style={{ fontSize: 11, marginLeft: 4 }}>
                              {studentData?.childSessionDetails?.feedback
                                ?.replace('<p>', '')
                                ?.replace('</p>', '')
                                ?.replace('<strong>', '')
                                ?.replace('</strong>', '')
                                ?.replace('<em>', '')
                                ?.replace('</em>', '')}
                            </Text>
                          </Text>
                          <Text
                            style={{
                              padding: 10,
                              fontSize: 12,
                              textAlign: 'left',
                              fontWeight: 500,
                            }}
                          >
                            Rating :
                            <Text style={{ fontSize: 10, marginLeft: 4 }}>
                              {studentData?.childSessionDetails?.rating
                                ? studentData?.childSessionDetails?.rating / 10
                                : ''}
                            </Text>
                          </Text>
                          <Text
                            style={{
                              padding: '0 10',
                              fontSize: 12,
                              textAlign: 'left',
                              fontWeight: 500,
                            }}
                          >
                            {locationData && (
                              <>
                                Session Recorded At :
                                <Text style={{ fontSize: 12, marginLeft: 0 }}>
                                  {locationData && locationData?.address?.city}{' '}
                                  {locationData && locationData?.address?.state}{' '}
                                  {locationData && locationData?.address?.country}
                                </Text>
                              </>
                            )}
                          </Text>
                        </View>
                      </View>
                    </View>

                    <View style={{ ...section, borderBottom: 'none' }}>
                      <View style={{ ...col, width: '35%', flexDirection: 'column' }}>
                        <View
                          style={{
                            width: '100%',
                            backgroundColor: '#e8e8e8',
                            textAlign: 'center',
                            borderBottom: '1px solid black',
                          }}
                        >
                          <Text style={headerText}>CAREGIVER SIGNATURE</Text>
                        </View>
                        <View style={{ width: '100%', height: 120, padding: 4 }}>
                          {CaregiverSign ? (
                            <View style={{ width: '100%' }}>
                              {CaregiverSign.signature !== '' && (
                                <Image
                                  alt="Clinic Logo"
                                  src={CaregiverSign.signature}
                                  style={{ width: '100px', alignSelf: 'center' }}
                                />
                              )}
                              <View>
                                <Text style={{ padding: 4, fontSize: 12 }}>
                                  {CaregiverSign?.user?.firstName}
                                </Text>
                                <Text style={{ padding: 4, fontSize: 12 }}>
                                  {CaregiverSignLocationData &&
                                    CaregiverSignLocationData?.address?.city}{' '}
                                  {CaregiverSignLocationData &&
                                    CaregiverSignLocationData?.address?.state}{' '}
                                  {CaregiverSignLocationData &&
                                    CaregiverSignLocationData?.address?.country}
                                </Text>
                                <Text style={{ fontSize: 12 }}>
                                  {moment(CaregiverSign?.createdAt).format('LT')}
                                </Text>
                              </View>
                            </View>
                          ) : (
                            <Text style={{ padding: 4 }}>signature</Text>
                          )}
                        </View>
                      </View>
                      <View style={{ ...col, width: '35%', flexDirection: 'column' }}>
                        <View
                          style={{
                            width: '100%',
                            backgroundColor: '#e8e8e8',
                            textAlign: 'center',
                            borderBottom: '1px solid black',
                          }}
                        >
                          <Text style={headerText}>PROVIDER SIGNATURE</Text>
                        </View>
                        <View style={{ width: '100%', height: 120, padding: 4 }}>
                          {ProviderSign ? (
                            <View style={{ width: '100%' }}>
                              {ProviderSign.signature !== '' && (
                                <>
                                  <Image
                                    alt="Clinic Logo"
                                    src={ProviderSign.signature}
                                    style={{ width: '100px', alignSelf: 'center' }}
                                  />
                                </>
                              )}
                              <View>
                                <Text style={{ padding: 4, fontSize: 12 }}>
                                  {ProviderSign?.user?.firstName}
                                </Text>
                                <Text style={{ padding: 4, fontSize: 12 }}>
                                  {ProviderSignLocationData &&
                                    ProviderSignLocationData?.address?.city}{' '}
                                  {ProviderSignLocationData &&
                                    ProviderSignLocationData?.address?.state}{' '}
                                  {ProviderSignLocationData &&
                                    ProviderSignLocationData?.address?.country}
                                </Text>
                                <Text style={{ fontSize: 12 }}>
                                  {moment(ProviderSign?.createdAt).format('LT')}
                                </Text>
                              </View>
                            </View>
                          ) : (
                            <Text style={{ padding: 4 }}>signature</Text>
                          )}
                        </View>
                      </View>
                      <View
                        style={{
                          ...col,
                          width: '30%',
                          flexDirection: 'column',
                          borderLeft: 'none',
                        }}
                      >
                        <View
                          style={{
                            width: '100%',
                            backgroundColor: '#e8e8e8',
                            textAlign: 'center',
                            borderBottom: '1px solid black',
                          }}
                        >
                          <Text style={headerTextBorder}>DATE</Text>
                        </View>
                        <View style={{ width: '100%', borderBottom: '1px solid black' }}>
                          <Text style={mText}>{moment().format('YYYY-MM-DD')}</Text>
                        </View>
                        <View style={{ width: '100%' }}>
                          <Text style={mText}> </Text>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              </Page>
            </Document>
          </PDFViewer>
        </>
      ) : (
        <LoadingComponent />
      )}

      <Modal
        title="Upload Signature"
        visible={IsModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Submit"
        footer={[
          <Button key="submit" type="primary" onClick={handleOk}>
            Submit
          </Button>,
          <Button key="back" type="primary" onClick={handleCancel}>
            cancel
          </Button>,
        ]}
      >
        <Upload.Dragger
          name="file"
          action={`${REACT_APP_API_URL}/signature-files/`}
          onChange={e => getSignImg(e)}
        >
          <p className="ant-upload-drag-icon">
            <Icon type="inbox" />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">
            Support for a single upload. Strictly prohibit from uploading company data or other band
            files
          </p>
        </Upload.Dragger>
        <br />
        OR
        <br />
        <br />
        <h4>Signature here</h4>
        <SignaturePad
          ref={sigCanvas}
          canvasProps={{
            className: 'signatureCanvas',
            style: {
              border: '1px dashed gray',
              width: '100%',
              borderRadius: '10px',
            },
          }}
        />
        <br />
        <Button onClick={save}>Save & view</Button>
        <Button onClick={clear}>Clear</Button>
        <br />
        <br />
        {SignImg && <img src={SignImg} alt="Sign" width="200" height="100" />}
      </Modal>
    </div>
  )
}

export default PrintableInvoice
